import React, { useEffect, useState } from 'react';
import api from '../../../services/api';
import logo from '../../../images/logoaccess.png';
import '../../../css/financeiro-parcela-pagar.css';
import { FaExternalLinkAlt } from 'react-icons/fa';

const logoStyle = {
  maxWidth: '100%',
  maxHeight: '48px',
  width: 'auto',
  height: 'auto',
  objectFit: 'contain',
};

export default function CadastroEventoParticipanteListaConcluido({ match }) {
  const id = match.params.id;
  const [evento, setEvento] = useState({});

  const buscar = () => {
    api({
      method: "get",
      action: '/eventoSemLogin/' + id,
    }).then(response => {
      var dadosEvento = response.data.data;
      setEvento(dadosEvento);
    }).catch(err => {
      //console.log(err)
    });
  };//buscar

  useEffect(() => { //onload
    buscar();
  },
    // eslint-disable-next-line
    []);

  return (
    <div
      className="fin-pp"
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundImage: 'none',
        backgroundColor: (evento.cor !== undefined) ? evento.cor : '#AAAAAA',
      }}
    >
      <div style={{ width: '100%', maxWidth: 480, padding: '0 16px' }}>
        <div className="fin-pp__card" style={{ padding: 32 }}>
          <div style={{ textAlign: 'center', marginBottom: 16 }}>
            {localStorage.getItem('logomarcaEvento') ?
              <img alt="" src={localStorage.getItem('logomarcaEvento')} style={logoStyle} className='mb-4' /> :
              <img alt="" src={logo} style={logoStyle} className='mb-4' />
            }
          </div>
          <p style={{ textAlign: 'center', color: 'var(--fin-tx)' }}>
            O seu cadastro no evento <strong>{evento.nome}</strong> foi realizado com sucesso!
          </p>
          {((evento.linkfinalcadastro ?? '') !== '') ?
            <>
              <p style={{ textAlign: 'center', color: 'var(--fin-mt)' }}>clique abaixo e acesse o material de apoio</p>
              <div style={{ textAlign: 'center', marginTop: 12 }}>
                <a
                  href={evento.linkfinalcadastro}
                  target="_blank"
                  rel="noreferrer"
                  className="fin-pp__btn fin-pp__btn--primary"
                >
                  <FaExternalLinkAlt size={16} style={{ marginRight: 6 }} />
                  Acessar Conteúdo
                </a>
              </div>
            </>
            : null
          }
        </div>
      </div>
    </div>
  );
}
